/* eslint-disable prefer-destructuring */
import { parseISO, format, parse, isAfter, lastDayOfMonth } from 'date-fns';
import {
  faCcVisa,
  faCcMastercard,
  faCcAmex,
  faCcDiscover,
} from '@fortawesome/free-brands-svg-icons';

export const CC_CARD_OPTIONS = {
  3: { name: 'Amex', display: faCcAmex },
  4: { name: 'Visa', display: faCcVisa },
  5: { name: 'Mastercard', display: faCcMastercard },
  7: { name: 'Discover', display: faCcDiscover },
};

export const DATE_FORMAT_FOR_RENDER = 'MMMM do, yyyy';

/**
 * Returns the name and Font-Awesome icon associated with a card issuer.
 *
 * @param {*} issuer - either the first digit of the card number or an issuer name
 * @returns {object}
 */
export function getCreditCardIssuerInfo(issuer) {
  if (!issuer) {
    return CC_CARD_OPTIONS[4];
  }

  if (typeof issuer === 'number') {
    return CC_CARD_OPTIONS[issuer] || CC_CARD_OPTIONS[4];
  }

  return Object.values(CC_CARD_OPTIONS).find(
    (cc) => cc.name.toLowerCase() === issuer.toLowerCase()
  );
}

export const usdFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

export function formatDate(date, formatString = DATE_FORMAT_FOR_RENDER) {
  try {
    let dateObj = date;

    if (typeof dateObj === 'string') {
      dateObj = parseISO(date);
    }
    return format(dateObj, formatString);
  } catch {
    return '';
  }
}

export const formatExpDate = (inputString) => {
  const stringArray = inputString
    .split('')
    .filter((character) => character >= 0 || character === '/');
  const formattedCheck = stringArray.includes('/');
  let output = '';
  if (stringArray.length === 2 && formattedCheck) {
    output += '0';
  }

  for (let i = 0; i <= stringArray.length - 1; i++) {
    if (i === 5 && formattedCheck) {
      break;
    }
    if (i === 4 && !formattedCheck) {
      break;
    }
    if (i === 2 && !formattedCheck) {
      output += '/';
    }
    output += stringArray[i];
  }
  return output;
};

export const formatCreditCard = (inputString, cardType) => {
  const stringArray = inputString
    .replaceAll(' ', '')
    .split('')
    .filter((character) => character >= 0);
  const length = cardType === 'Amex' ? 14 : 15;
  let output = '';
  for (let i = 0; i <= length; i++) {
    if (i === stringArray.length) {
      break;
    }

    if (length === 15 && (i === 4 || i === 8 || i === 12)) {
      output += ' ';
    }

    if (length === 14 && (i === 4 || i === 10)) {
      output += ' ';
    }
    output += stringArray[i];
  }
  return output;
};

export const validateExpDate = (inputDate) => {
  if (inputDate.length < 5) {
    return false;
  }

  const firstStepDate = parse(`${inputDate}/01`, 'MM/yy/dd', new Date());
  const lastDay = lastDayOfMonth(firstStepDate);
  const checkIsAfter = isAfter(lastDay, new Date());

  return checkIsAfter;
};

export const validateCreditCard = (inputNumber, cardType) => {
  const length = inputNumber.replaceAll(' ', '').length;
  if (cardType === 'Amex') {
    return length === 15;
  }
  return length === 16;
};
